import { render, staticRenderFns } from "./EventMicrositeNew2.vue?vue&type=template&id=8536c064&scoped=true"
import script from "./EventMicrositeNew2.vue?vue&type=script&lang=js"
export * from "./EventMicrositeNew2.vue?vue&type=script&lang=js"
import style0 from "./EventMicrositeNew2.vue?vue&type=style&index=0&id=8536c064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536c064",
  null
  
)

export default component.exports